import { v4 as uuidv4 } from 'uuid';
import billingApiAgent from '../../services/api/billingApiAgent';
import { store } from '../store';
import { createCompanyFieldStore } from '../companyField/createCompanyFieldStore';
import PurchaseStore from './purchaseStore';

/**
 * The composition root of the purchase store: the one place it meets the billing agent, the balance
 * store, its company field and the UUIDs its idempotency keys are. The balance store is reached lazily, inside the port, because the root
 * store is still being built when this runs.
 */
export const createPurchaseStore = (): PurchaseStore =>
  new PurchaseStore({
    agent: billingApiAgent,
    acceptBalance: (balance) => store.balanceStore.accept(balance),
    companyField: createCompanyFieldStore(),
    newKey: () => uuidv4(),
  });
